module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/rumble-8f8bd65d35d24a245a004b261584d9bf.png";